import { storeToRefs } from 'pinia';

import { useFeatureFlagsStore } from '~/stores/featureFlags';
import { useRegionStore } from '~/stores/region';

function subregionForApi(store: ReturnType<typeof useRegionStore>) {
  return (store.subregionName || store.subregionIbge || '').trim();
}

function zipcodeForApiValue(store: ReturnType<typeof useRegionStore>) {
  return (store.zipcode || '').trim();
}

export function useRegionMultiCd() {
  const { multiCd } = storeToRefs(useFeatureFlagsStore());
  const regionStore = useRegionStore();

  function subregionAndZipcodeForApi() {
    return {
      subregion: subregionForApi(regionStore),
      zipcode: zipcodeForApiValue(regionStore),
    };
  }

  function zipcodeForApi() {
    const zip = zipcodeForApiValue(regionStore);
    if (!zip) {
      return {};
    }
    return { zipcode: zip };
  }

  return { multiCd, subregionAndZipcodeForApi, zipcodeForApi };
}
